import { Content, ContentColumns } from "pdfmake/interfaces";
import svg from "report/common/svg";

const get = (
  t: any,
  layerId: string,
  fontSize: number = 8,
  opacity: number = 0.6
): Content => {
  const isFathomLayer = layerId.toLowerCase().includes("fathom");
  const fathomSuffix = t("drawShape.1-in-1000-year scenario (Undefended)") || "";
  const layerText = `${t("layerId." + layerId)}${
    isFathomLayer ? fathomSuffix : ""
  }`;

  const layerTitle: ContentColumns = {
    columns: [
      svg[layerId] && {
        svg: svg[layerId],
        fit: [12, 12],
        width: 12
      },
      {
        text: layerText,
        width: "*",
        margin: [3, 0, 6, 0]
      }
    ],
    fontSize,
    opacity,
    lineHeight: 1,
    characterSpacing: 0
  };

  if (isFathomLayer) {
    layerTitle.columns.push({
      svg: svg.premium,
      fit: [12, 12],
      width: 12
    });
  }

  return layerTitle;
};

export default get;
